var anim8 = require('./anim8.js')
module.exports = function (page) {
	document.querySelectorAll('[am-page]').forEach(anim8.hide)
	document.querySelectorAll('[am-page-fragment]').forEach(anim8.hide)
	var pageElement = document.querySelector('[am-page="' + page + '"]')
	anim8(pageElement, 'show')
	var deps = pageElement.getAttribute('am-depends')
	if (deps !== null) {
		deps.split(' ').forEach(function (fragment) {
			anim8(document.querySelector('[am-page-fragment="' + fragment + '"]'), 'show')
		})
	}
}
